import React from "react";
import { FormProps } from "Utilities/Types";
import Error from "Components/InputsForm/Error";

const Textarea: React.FC<FormProps> = ({ register, errors, placeholder }) => {
  const minLengthText = {
    value: 20,
    message: "minLengthDescription",
  };

  return (
    <>
      <textarea
        className={
          errors.message ? "input input-focus invalid" : "input input-focus"
        }
        id="message"
        placeholder={placeholder}
        {...register("message", {
          required: true,
          minLength: {
            value: minLengthText.value,
            message: minLengthText.message,
          },
          onblur: () => null,
        })}
      />
      <Error error={errors.message} />
    </>
  );
};

export default Textarea;
